import React from "react";
import { Form, Button, Col, Row } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

import TimeInput from "../../Inputs/TimeInput";

const BreakTimeShiftForm = ({ driverId, breakStart, breakEnd, onSubmit }) => {
  const [form] = Form.useForm();

  const handleOnFinish = values => {
    const params = {
      breakStart: values.breakStart,
      breakEnd: values.breakEnd,
    };
    onSubmit({ driver: driverId, ...params });
  };

  const handleOnChangeTimePicker = (type, value) => {
    if (type === "start") form.setFieldsValue({ breakStart: value });
    if (type === "end") form.setFieldsValue({ breakEnd: value });
  };

  return (
    <Form form={form} initialValues={{ breakStart, breakEnd }} onFinish={handleOnFinish}>
      <Row align="middle">
        <Col>
          <TimeInput
            name="breakStart"
            required={false}
            styleInput={{ width: 50, height: 32, padding: 4, fontSize: 14 }}
            styleForm={{ margin: 0 }}
            suffixIcon={false}
            onChange={value => handleOnChangeTimePicker("start", value)}
            value={form.getFieldValue("breakStart")}
          />
        </Col>
        <Col style={{ marginLeft: 5 }}>
          <TimeInput
            name="breakEnd"
            required={false}
            styleInput={{ width: 50, height: 32, padding: 4, fontSize: 14 }}
            styleForm={{ margin: 0 }}
            suffixIcon={false}
            onChange={value => handleOnChangeTimePicker("end", value)}
            value={form.getFieldValue("breakEnd")}
          />
        </Col>
        <Col style={{ marginLeft: 5 }}>
          <Button htmlType="submit" type="primary" icon={<CheckCircleOutlined />} style={{ height: 30, width: 30 }} />
        </Col>
      </Row>
    </Form>
  );
};

export default BreakTimeShiftForm;
